export const INSTANT_SEARCH_INDEX_NAME = 'frisearchable_posts';
// export const INSTANT_SEARCH_QUERY_SUGGESTIONS =
//   'instant_search_demo_query_suggestions';
export const INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES = [
  'taxonomies_hierarchical.subject_area.lvl0',
  'taxonomies_hierarchical.subject_area.lvl1',
];
export const INSTANT_SEARCH_HIERARCHICAL_PTYPE = [
  'taxonomies_hierarchical.publication_type.lvl0',
  'taxonomies_hierarchical.publication_type.lvl1',
];
